define('views/pages/trade/offer/repeat/index',[
    'jquery',
    'underscore',
    'mediator',
    'models/base/modal',
    'views/base/view',
    'views/base/modal',
    'lib/utils',

    'text!templates/pages/trade/offer/repeat/index.ejs',

    'views/pages/trade/offer/repeat/table',
    'views/pages/trade/offer/repeat/navbar',
    'views/pages/trade/offer/repeat/sidebar'

], function($, _, mediator, ModalModel, View, ModalView, utils, template, RepeatTableView, RepeatNavbarView, RepeatSidebarView) {
    'use strict';

    var RepeatContentView = View.extend({
        autoRender: true,
        region: 'modal-content',
        regions: {
            'repeat-table': '#repeat-table-container',
            'repeat-sidebar': '#repeat-sidebar-container',
            'repeat-navbar': '#repeat-navbar-container'
        },
        template: template,
        render: function() {
            View.prototype.render.apply(this, arguments);

            this.subview('navbar', new RepeatNavbarView({ model: this.model }));
            this.subview('sidebar', new RepeatSidebarView({ collection: this.model.trade.items, model: this.model }));
            this.subview('table', new RepeatTableView({ collection: this.model.request.items, model: this.model }));
        }
    });

    var RepeatModalView = ModalView.extend({
        render: function() {
            ModalView.prototype.render.apply(this, arguments);
            this.subview('content', new RepeatContentView({ model: this.model }));
        }
    });

    return RepeatModalView;
});

